/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import LocalContext from "../Context/LocalContetxt";
import ProfileReq from "../Utility/Requester/ProfileReq";
import Urls from "../Utility/Urls";

const initResume = { experience: [], education: [], certificate: [] };

export default function useGetProfileInfoHook() {
  const [data, setData] = useState(null);
  const [resume, setResume] = useState(null);
  const config = useContext(LocalContext).config;

  const fetchResume = (fileName) => {
    Axios({
      method: "GET",
      responseType: "json",
      baseURL: Urls.resume(),
      url: fileName,
    })
      .then((response) => {
        setResume(response.data);
      })
      .catch(() => {
        setResume({ ...initResume, isCreate: true });
      });
  };

  const getResume = (data) => {
    ProfileReq.Resume(data.UserID)
      .then((resume) => {
        if (resume.data.Resume) {
          let fileName = resume.data.Resume;
          fetchResume(fileName);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setResume({ ...initResume, isCreate: true });
      });
  };

  useEffect(() => {
    if (config && config.role === "Teacher") {
      ProfileReq.Profile()
        .then((res) => {
          setData(res.data);
          getResume(res.data);
        })
        .catch((err) => {});
    } else {
      setData(config);
    }
  }, [config]);

  return {
    data,
    resume,
    info: config,
  };
}
